import { Pipe, PipeTransform } from '@angular/core';
import { AttributeDefinitionType } from '../models/attributes/attributeDefinitionType';

@Pipe({
  name: 'customFieldTitle',
  standalone: false
})
export class CustomFieldTitlePipe implements PipeTransform {
  transform(definitionType: string, tabName: string): string {
    return definitionType == AttributeDefinitionType.SubField
      ? `${tabName} Sub Fields`
      : `${tabName} Fields`;
  }
}
